import {Component} from '@angular/core';

@Component({
    selector: 'tfl-internal-transfer-icon',
    template: require('./internal.html')
})
export class InternalTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/internal/internal.transfer.icon.ts